import { render, staticRenderFns } from "./CreateRegionPricing.vue?vue&type=template&id=3f332b98"
import script from "./CreateRegionPricing.vue?vue&type=script&lang=js"
export * from "./CreateRegionPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports